function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import React from "react";
import Error from "./Error/index";
const WithFieldsCheck = (Component, options = {}) => {
  return props => {
    const routeField = options.routeField;
    const placeholderName = options.placeholderName;
    const checkPlaceholderItems = componentPlaceholder => {
      for (let i = 0; i < componentPlaceholder.length; i += 1) {
        // Placeholder components still show and get iterated over in experience editor mode though they
        // Appear with a different object makeup so a check for 'attributes' rules out regular placeholders
        if (!componentPlaceholder[i].fields && !componentPlaceholder[i].hasOwnProperty("attributes")) {
          return true;
        }
      }
      return false;
    };

    // Check route data for a field
    if (options.routeField !== undefined && !props.sitecoreContext.route.fields[routeField]) {
      return /*#__PURE__*/React.createElement(Error, _extends({
        contextError: "route"
      }, props));
    }

    // Check for datasource
    if (options.routeField === undefined && options.placeholderName === undefined && !props.rendering.fields) {
      return /*#__PURE__*/React.createElement(Error, _extends({
        contextError: "rendering"
      }, props));
    }

    // Check for datasource on placeholder items
    if (options.placeholderName !== undefined) {
      if (checkPlaceholderItems(props.rendering.placeholders[placeholderName])) {
        return /*#__PURE__*/React.createElement(Error, _extends({
          contextError: "placeholder"
        }, props));
      }
    }
    return /*#__PURE__*/React.createElement(Component, props);
  };
};
export default WithFieldsCheck;